import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { memo, useContext, useState, useEffect } from 'react'
import { OfrecerPremiumContext } from './ofrecerPremium.context'
import { connect } from 'react-redux'
import { Close } from '@mui/icons-material'
import { styled } from '@mui/material/styles'
import { IAnuncio, useAnuncios } from '../../pages/Home/hooks/anuncios.hook'
import CloseIcon from '@mui/icons-material/Close'
import { LocalContext } from '../../pages/AdminLocal/context/local.context'

const Cabecera = (props: any) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'start',
        height: '130px',
        width: '100%',
        bgcolor: props.header_bgcolor,
        backgroundImage: `url(${props.header_img})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center'
      }}
    >
      <IconButton
        onClick={props.onClose}
        sx={{
          color: (theme) => theme.palette.grey[100]
        }}
      >
        <Close />
      </IconButton>
    </Box>
  )
}

interface PageProps {
  page: number
}

interface PreOfrecerPremiumDialogProps {
  text?: string
  header_img?: string
  header_bgcolor?: string
}

const PreOfrecerPremiumDialog = ({ text, header_img, header_bgcolor }: PreOfrecerPremiumDialogProps) => {
  const { openPre, onClosePre, onOpen } = useContext(OfrecerPremiumContext)

  return (
    <Dialog open={openPre} onClose={onClosePre} fullWidth>
      <Cabecera onClose={onClosePre} header_img={header_img} header_bgcolor={header_bgcolor} />
      <DialogContent>
        <Typography variant="h6" fontWeight={'bold'}>
          {text || ''}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onOpen} color="success">
          ¡Quiero mejorar mi exposición!
        </Button>
        <Button onClick={onClosePre}>Lo tendré en cuenta</Button>
      </DialogActions>
    </Dialog>
  )
}

const OfrecerPremiumDialog = (props: any) => {
  const { open, onClose, openPre } = useContext(OfrecerPremiumContext)
  const { codLocal } = props.logged.userLogged
  const { local, loading } = useContext(LocalContext)
  const [index, setIndex] = useState<number>(0)
  const [ofrecerPremium, setOfrecerPremium] = useState<boolean>(false)
  const { anuncios, idBannerConfig } = useAnuncios(codLocal)
  const bannerPremium = anuncios?.find((a: IAnuncio) => a.idAnuncio === parseInt(idBannerConfig))
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const handleClick = () => {
    if (index === 0) setIndex(1)
    else {
      window.open(bannerPremium.detalleLink)
    }
  }

  const handleClose = () => {
    setIndex(0)
    onClose()
  }

  useEffect(() => {
    const show = local?.config?.find((c: any) => c.name === 'premium_ofrecerPremium')?.value
    setOfrecerPremium(show === 'true' ? true : false)
  }, [local])

  if (loading || !local || !ofrecerPremium || !bannerPremium?.detalleImagenList) return null

  if (openPre)
    return (
      <PreOfrecerPremiumDialog
        header_img={local.config.find((c: any) => c.name === 'premium_bannerFullScreen_header_img')?.value}
        header_bgcolor={local.config.find((c: any) => c.name === 'premium_bannerFullScreen_header_bgcolor')?.value}
        text={local.config.find((c: any) => c.name === 'premium_ABMproductos_postText')?.value}
      />
    )

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: {
          display: 'flex',
          maxWidth: '100%',
          maxHeight: '100%'
        }
      }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          size="small"
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            backgroundColor: 'white',
            borderRadius: '50%',
            padding: '2px',
            '&:hover': {
              backgroundColor: 'white'
            },
            ...(isMobile && {
              width: 20,
              height: 20
            })
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
        <img
          key={index}
          src={bannerPremium.detalleImagenList[index]?.url || ''}
          alt="Premium Avellaneda a Un Toque"
          style={{
            objectFit: 'contain',
            maxWidth: '100%',
            maxHeight: '80vh',
            margin: 0,
            padding: 0
          }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClick} fullWidth variant="contained" sx={{ mt: 2 }}>
          {index === 0 ? 'Siguiente' : bannerPremium.detalleTexto ? bannerPremium.detalleTexto : 'Contactanos'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged
  }
}

export default connect(mapStateToProps)(memo(OfrecerPremiumDialog))
